import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';

import getParams from '@dashboard/services/getParams';

import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import logException from '@dashboard/services/logException';
import { navigateFromDashboard } from '@dashboard/utils/storeSetupRedirect';
import Logo from '@dashboard/components/Logo';
import Spinner from '@dashboard/components/Spinner';

import { connectPaymentGateway } from './helpers';
import StripeLogo from './stripe.png';
import { googleTag } from '@/dashboard/lib/tracking';

export default function SellerConnectStripe() {
  const { setSeller, token, sellerId } = useAuth();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    async function connectStripe() {
      const urlParams = getParams(location.search);

      try {
        if (urlParams.error || urlParams.error_description) {
          if (urlParams.error === 'access_denied') {
            if (urlParams.state) {
              navigateFromDashboard(urlParams.state.replace('/dashboard', ''), history.push);
            } else {
              history.push('/settings/stripe');
            }

            return;
          } else {
            throw new Error();
          }
        }

        const response = await connectPaymentGateway(urlParams, sellerId, 'stripe', token);

        if (response.data) {
          setSeller(response.data);

          // track connect stripe account conversion event
          googleTag.track('conversion', { send_to: 'AW-16833295745/eo1YCP_gtcMbEIHr3to-' });

          if (urlParams.state) {
            navigateFromDashboard(urlParams.state.replace('/dashboard', ''), history.push);
          } else {
            history.push('/');
          }
        } else {
          throw new Error();
        }
      } catch (error) {
        window.alert('Failed to connect your Stripe account. Please try again or contact support.');

        // `code` is single-use and exchanges for the connected account's keys,
        // and the seller's JWT has no business in Sentry at all.
        // eslint-disable-next-line no-unused-vars -- code intentionally dropped
        const { code, ...loggableParams } = urlParams;

        logException({
          message: 'Failed to connect Stripe account',
          urlParams: loggableParams,
          sellerId,
          error,
        });

        if (urlParams.state) {
          navigateFromDashboard(urlParams.state.replace('/dashboard', ''), history.push);
        } else {
          history.push('/settings/stripe');
        }
      }
    }

    connectStripe();
  }, [location, sellerId, token, history, setSeller]);

  return (
    <>
      <div className="mb-8 text-center">
        <Spinner className="mx-auto w-12 h-12 mb-8" />
        <h1 className="text-xl">Connecting to Stripe</h1>
      </div>

      <div className="flex flex-row justify-between w-full relative gap-x-10">
        <div className="w-full flex items-center border border-gray-100 dark:border-border rounded p-4 bg-white dark:bg-background z-10">
          <div className="h-auto mx-auto">
            <Logo size={48} />
          </div>
        </div>
        <div className="bg-gray-100 dark:bg-muted my-auto absolute top-0 bottom-0 w-full h-px" />
        <div className="w-full flex items-center border border-gray-100 dark:border-border rounded p-4 bg-white dark:bg-background z-10">
          <img className="w-full max-w-32 h-auto mx-auto" src={StripeLogo} />
        </div>
      </div>
    </>
  );
}
